<div class="calculation"  [ngClass]="{ expanded: isExpanded }">
  <form [formGroup]="form">
    <div class="diro">
      <h4>DIRO</h4>
      <!-- Mostrar "netInterestMargin" solo si el dato está disponible-->
      <div class="netInterestMargin">
        <span class="title">Net interest margin</span>

        <div class="data">
          <span class="type">Effective</span>
          <span class="value">{{netInterestMarginEffective}}%</span>
        </div>
        <div class="data">
          <span class="type">Nominal</span>
          <span class="value">{{netInterestMarginNominal}}%</span>
        </div>
      </div>
      <div>
        <div>
          <a href="{{ urlQuote }}" target="_blank">Quote ID</a>
          <input type="number" [disabled]="true" formControlName="idQuote" tabindex="61" />
        </div>
        <div>
          <a href="{{ urlDeal }}" target="_blank">Deal ID</a>
          <input type="number" [disabled]="true" formControlName="idDeal" tabindex="62" />
        </div>
      </div>
      <a class="accordionControl" style="cursor: pointer" (click)="toggleAccordion()" tp="{{ !isExpanded ? 'Ver detalle' : 'Ocultar detalle' }}" (keydown.enter)="toggleAccordion()" tabindex="63"></a>
    </div>
    <div class="accordionWrapper" *ngIf="isExpanded">
      <div>
        <div class="diroWrapper">
          <div class="formWrapper">
            <h5>
              <span class="col">Calculation results</span>
              <span class="col">Effective</span>
              <span class="col">Nominal</span>
            </h5>

            <!-- Customer rate in -->
            <div class="row big">
              <div class="col">
                <label for="customerRateEffective">Customer rate in</label>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="customerRateEffective"
                  formControlName="customerRateEffective"
                  tabindex="64"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('customerRateEffective')?.invalid &&
                    (form.get('customerRateEffective')?.dirty ||
                      form.get('customerRateEffective')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('customerRateEffective')?.errors?.['required']"
                    class="error"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('customerRateEffective')?.hasError('pattern')
                    "
                    class="error"
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="customerRateNominal"
                  formControlName="customerRateNominal"
                  tabindex="65"
                />
                <span>%</span>
                <div>
                  <div
                    *ngIf="
                      form.get('customerRateNominal')?.invalid &&
                      (form.get('customerRateNominal')?.dirty ||
                        form.get('customerRateNominal')?.touched)
                    "
                  >
                    <div
                      *ngIf="form.get('customerRateNominal')?.errors?.['required']"
                    >
                      Este campo es requerido.
                    </div>
                    <div
                      *ngIf="
                        form.get('customerRateNominal')?.hasError('pattern')
                      "
                    >
                      Ingresa un número válido con hasta 2 decimales.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- + IDCs/Subsidies/Fees(upfront) -->
            <div class="row">
              <div class="colSpan">
                <label for="iDcsSubsidiesFeesNominal"
                  >+ IDCs/Subsidies/Fees(upfront)</label
                >
              </div>
              <div class="col">
                <input
                  type="text"
                  id="iDcsSubsidiesFeesNominal"
                  formControlName="iDcsSubsidiesFeesNominal"
                  tabindex="66"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('iDcsSubsidiesFeesNominal')?.invalid &&
                    (form.get('iDcsSubsidiesFeesNominal')?.dirty ||
                      form.get('iDcsSubsidiesFeesNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('iDcsSubsidiesFeesNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('iDcsSubsidiesFeesNominal')?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <!-- = Deal rate (IRR) -->
            <div class="row big">
              <div class="col">
                <label for="dealRateEffective">= Deal rate (IRR)</label>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="dealRateEffective"
                  formControlName="dealRateEffective"
                  tabindex="67"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('dealRateEffective')?.invalid &&
                    (form.get('dealRateEffective')?.dirty ||
                      form.get('dealRateEffective')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('dealRateEffective')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="form.get('dealRateEffective')?.hasError('pattern')"
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="dealRateNominal"
                  formControlName="dealRateNominal"
                  tabindex="68"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('dealRateNominal')?.invalid &&
                    (form.get('dealRateNominal')?.dirty ||
                      form.get('dealRateNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('dealRateNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div *ngIf="form.get('dealRateNominal')?.hasError('pattern')">
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <!-- - Cost of Debt (100% Matched Funded) -->
            <div class="row">
              <div class="colSpan">
                <label for="costOfDebtNominal"
                  >- Cost of Debt (100% Matched Funded)</label
                >
              </div>
              <div class="col">
                <input
                  type="text"
                  id="costOfDebtNominal"
                  formControlName="costOfDebtNominal"
                  tabindex="69"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('costOfDebtNominal')?.invalid &&
                    (form.get('costOfDebtNominal')?.dirty ||
                      form.get('costOfDebtNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('costOfDebtNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="form.get('costOfDebtNominal')?.hasError('pattern')"
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <!-- = Grost interest margin -->
            <div class="row big">
              <div class="col">
                <label for="grossInterestMarginEffective"
                  >= Grost interest margin</label
                >
              </div>
              <div class="col">
                <input
                  type="text"
                  id="grossInterestMarginEffective"
                  formControlName="grossInterestMarginEffective"
                  tabindex="70"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('grossInterestMarginEffective')?.invalid &&
                    (form.get('grossInterestMarginEffective')?.dirty ||
                      form.get('grossInterestMarginEffective')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('grossInterestMarginEffective')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form
                        .get('grossInterestMarginEffective')
                        ?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="grossInterestMarginNominal"
                  formControlName="grossInterestMarginNominal"
                  tabindex="71"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('grossInterestMarginNominal')?.invalid &&
                    (form.get('grossInterestMarginNominal')?.dirty ||
                      form.get('grossInterestMarginNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('grossInterestMarginNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form
                        .get('grossInterestMarginNominal')
                        ?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <!-- - Capital Advantage (incl. Security deposit and NIBIT) -->
            <div class="row">
              <div class="colSpan">
                <label for="grossInterestMarginEffective"
                  >- Capital Advantage (incl. Security deposit and NIBIT)</label
                >
              </div>
              <div class="col">
                <label for="capitalAdvantageNominal"></label>
                <input
                  type="text"
                  id="capitalAdvantageNominal"
                  formControlName="capitalAdvantageNominal"
                  tabindex="72"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('capitalAdvantageNominal')?.invalid &&
                    (form.get('capitalAdvantageNominal')?.dirty ||
                      form.get('capitalAdvantageNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('capitalAdvantageNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('capitalAdvantageNominal')?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <!-- = Net interest margin -->
            <div class="row big">
              <div class="col">
                <label for="netInterestMarginEffective"
                  >= Net interest margin</label
                >
              </div>
              <div class="col">
                <input
                  type="text"
                  id="netInterestMarginEffective"
                  formControlName="netInterestMarginEffective"
                  tabindex="73"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('netInterestMarginEffective')?.invalid &&
                    (form.get('netInterestMarginEffective')?.dirty ||
                      form.get('netInterestMarginEffective')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('netInterestMarginEffective')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form
                        .get('netInterestMarginEffective')
                        ?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="netInterestMarginNominal"
                  formControlName="netInterestMarginNominal"
                  tabindex="74"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('netInterestMarginNominal')?.invalid &&
                    (form.get('netInterestMarginNominal')?.dirty ||
                      form.get('netInterestMarginNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('netInterestMarginNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('netInterestMarginNominal')?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <!-- - Standard cost of credit risk -->
            <div class="row">
              <div class="colSpan">
                <label for="standardCostOfCreditRiskNominal"
                  >- Standard cost of credit risk</label
                >
              </div>
              <div class="col">
                <input
                  type="text"
                  id="standardCostOfCreditRiskNominal"
                  formControlName="standardCostOfCreditRiskNominal"
                  tabindex="75"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('standardCostOfCreditRiskNominal')?.invalid &&
                    (form.get('standardCostOfCreditRiskNominal')?.dirty ||
                      form.get('standardCostOfCreditRiskNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="
                form.get('standardCostOfCreditRiskNominal')?.errors?.['required']
              "
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form
                        .get('standardCostOfCreditRiskNominal')
                        ?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <!-- - OPEX -->
            <div class="row">
              <div class="colSpan">
                <label for="opexNominal">- OPEX</label>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="opexNominal"
                  formControlName="opexNominal"
                  tabindex="76"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('opexNominal')?.invalid &&
                    (form.get('opexNominal')?.dirty ||
                      form.get('opexNominal')?.touched)
                  "
                >
                  <div *ngIf="form.get('opexNominal')?.errors?.['required']">
                    Este campo es requerido.
                  </div>
                  <div *ngIf="form.get('opexNominal')?.hasError('pattern')">
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <!-- Fees/ Subs.(periodic) -->
            <div class="row">
              <div class="colSpan">
                <label for="freeSubsNominal">Fees/ Subs.(periodic)</label>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="freeSubsNominal"
                  formControlName="freeSubsNominal"
                  tabindex="77"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('freeSubsNominal')?.invalid &&
                    (form.get('freeSubsNominal')?.dirty ||
                      form.get('freeSubsNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('freeSubsNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div *ngIf="form.get('freeSubsNominal')?.hasError('pattern')">
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <!-- = Net EBIT margin -->
            <div class="row big">
              <div class="col">
                <label for="netEbItMarginEffective">= Net EBIT margin</label>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="netEbItMarginEffective"
                  formControlName="netEbItMarginEffective"
                  tabindex="78"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('netEbItMarginEffective')?.invalid &&
                    (form.get('netEbItMarginEffective')?.dirty ||
                      form.get('netEbItMarginEffective')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('netEbItMarginEffective')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('netEbItMarginEffective')?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="netEbItMarginNominal"
                  formControlName="netEbItMarginNominal"
                  tabindex="79"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('netEbItMarginNominal')?.invalid &&
                    (form.get('netEbItMarginNominal')?.dirty ||
                      form.get('netEbItMarginNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('netEbItMarginNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('netEbItMarginNominal')?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>

            <!-- / Economic Capital -->
            <div class="row">
              <div class="colSpan">
                <label for="economicCapitalNominal">/ Economic Capital</label>
              </div>
              <div class="col">
                <input
                  type="text"
                  id="economicCapitalNominal"
                  formControlName="economicCapitalNominal"
                  tabindex="80"
                />
                <span>%</span>
                <div
                  *ngIf="
                    form.get('economicCapitalNominal')?.invalid &&
                    (form.get('economicCapitalNominal')?.dirty ||
                      form.get('economicCapitalNominal')?.touched)
                  "
                >
                  <div
                    *ngIf="form.get('economicCapitalNominal')?.errors?.['required']"
                  >
                    Este campo es requerido.
                  </div>
                  <div
                    *ngIf="
                      form.get('economicCapitalNominal')?.hasError('pattern')
                    "
                  >
                    Ingresa un número válido con hasta 2 decimales.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Otros valores -->
          <div class="otherValues">
            <div>
              <label for="plf">PLF</label>
              <div class="wrapper">
                <input type="text" id="plf" formControlName="plf" tabindex="81" />
                <span>%</span>
              </div>
              <div
                *ngIf="
                  form.get('plf')?.invalid &&
                  (form.get('plf')?.dirty || form.get('plf')?.touched)
                "
              >
                <div *ngIf="form.get('plf')?.errors?.['required']">
                  Este campo es requerido.
                </div>
                <div *ngIf="form.get('plf')?.hasError('pattern')">
                  Ingresa un número válido con hasta 2 decimales.
                </div>
              </div>
            </div>

            <!-- PLS -->
            <div>
              <label for="pls">PLS</label>
              <div class="wrapper">
                <input type="text" id="pls" formControlName="pls" tabindex="82" />
                <span>%</span>
              </div>
              <div
                *ngIf="
                  form.get('pls')?.invalid &&
                  (form.get('pls')?.dirty || form.get('pls')?.touched)
                "
              >
                <div *ngIf="form.get('pls')?.errors?.['required']">
                  Este campo es requerido.
                </div>
                <div *ngIf="form.get('pls')?.hasError('pattern')">
                  Ingresa un número válido con hasta 2 decimales.
                </div>
              </div>
            </div>

            <!-- DFS master scale -->
            <div>
              <label for="dfsMasterScale">DFS master scale</label>
              <div class="wrapper">
                <input
                  type="text"
                  id="dfsMasterScale"
                  formControlName="dfsMasterScale"
                  tabindex="83"
                />
                <span>%</span>
              </div>
              <div
                *ngIf="
                  form.get('dfsMasterScale')?.invalid &&
                  (form.get('dfsMasterScale')?.dirty ||
                    form.get('dfsMasterScale')?.touched)
                "
              >
                <div *ngIf="form.get('dfsMasterScale')?.errors?.['required']">
                  Este campo es requerido.
                </div>
                <div *ngIf="form.get('dfsMasterScale')?.hasError('pattern')">
                  Ingresa un número válido con hasta 2 decimales.
                </div>
              </div>
            </div>

            <!-- Effective Maturity -->
            <div>
              <label for="effectiveMaturity">Effective Maturity</label>
              <div class="wrapper">
                <input
                  type="text"
                  id="effectiveMaturity"
                  formControlName="effectiveMaturity"
                  tabindex="84"
                />
                <span>%</span>
              </div>
              <div
                *ngIf="
                  form.get('effectiveMaturity')?.invalid &&
                  (form.get('effectiveMaturity')?.dirty ||
                    form.get('effectiveMaturity')?.touched)
                "
              >
                <div
                  *ngIf="form.get('effectiveMaturity')?.errors?.['required']"
                >
                  Este campo es requerido.
                </div>
                <div *ngIf="form.get('effectiveMaturity')?.hasError('pattern')">
                  Ingresa un número válido con hasta 2 decimales.
                </div>
              </div>
            </div>

            <!-- Customer installment -->
            <div>
              <label for="customerInstallment">Customer installment</label>
              <div class="wrapper">
                <input
                  type="text"
                  id="customerInstallment"
                  class="amount gapRight"
                  style="display: none"
                  formControlName="customerInstallment"
                  (blur)="hideAmountInput('customerInstallment')"
                  tabindex="85"
                />
                <input
                  type="text"
                  #hiddenCustomerInstallment
                  id="hidden-customerInstallment"
                  class="amount gapRight"
                  (focus)="showAmountInput('customerInstallment')"
                  style="display: block"
                  [value]="
                    form.controls['customerInstallment'].value
                      | currency : '' : ''
                  "
                  tabindex="85"
                />
              </div>
              <div
                *ngIf="
                  form.get('customerInstallment')?.invalid &&
                  (form.get('customerInstallment')?.dirty ||
                    form.get('customerInstallment')?.touched)
                "
              >
                <div
                  *ngIf="form.get('customerInstallment')?.errors?.['required']"
                >
                  Este campo es requerido.
                </div>
              </div>
            </div>

            <!-- Calculation as of -->
            <div>
              <label for="calculationOf">Calculation as of</label>
              <input
                type="date"
                id="calculationOf"
                formControlName="calculationOf"
                tabindex="86"
              />
            </div>

            <!-- Interest as of -->
            <div>
              <label for="interestAsOf">Interest as of</label>
              <input
                type="date"
                id="interestAsOf"
                formControlName="interestAsOf"
                tabindex="87"
              />
            </div>

            <!-- Spreads as of -->
            <div>
              <label for="spreadsAsOf">Spreads as of</label>
              <input
                type="date"
                id="spreadsAsOf"
                formControlName="spreadsAsOf"
                tabindex="88"
              />
            </div>

            <!-- Created on -->
            <div>
              <label for="createOn">Created on</label>
              <input type="date" id="createOn" formControlName="createOn" tabindex="89" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
